import type { InfraEventPassengerCount } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/types";
import type { PassengerPredictionsResponse } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";

/**
 * Transforms PassengerPredictionsResponse to the flat InfraEventPassengerCount[] format
 * used by the AreaChart components.
 */
export function transformPredictionsToChartData(
  response: PassengerPredictionsResponse,
  incidentStretchName?: string,
): InfraEventPassengerCount[] {
  if (!response || !response.measureStretches) {
    return [];
  }

  if (response.measureStretches.length === 0) {
    const predictions = response.incidentStretchPredictions ?? [];
    return predictions.map((prediction) => ({
      stretch: incidentStretchName ?? "",
      date: new Date(prediction.fromTime),
      passengers: prediction.passengersRequiringTransport ?? 0,
    }));
  }
  return response.measureStretches.flatMap((measureStretch) => {
    const stretch = `${measureStretch.fromStop?.jbvId}–${measureStretch.toStop?.jbvId}`;

    return (measureStretch.predictions ?? []).map((prediction) => ({
      stretch,
      date: new Date(prediction.fromTime),
      passengers: prediction.passengersRequiringTransport ?? 0,
    }));
  });
}
